<ng-container *ngIf="status">
    <p>{{ 'INIT.ERROR.' + status | translate }}</p>
    <div class="row">
        <div translate class="col-2 f-b">INIT.STATUS</div>
        <div class="col-10">{{ status }}</div>
    </div>
    <div class="row">
        <div translate class="col-2 f-b">INIT.MSG</div>
        <div class="col-10">{{ message }}</div>
    </div>
</ng-container>

<ng-container *ngIf="!status">

    <p>{{ 'INIT.STEP_ACCOUNT' | translate }}</p>
    <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{'SETTINGS.ACCOUNT_NAME' | translate }}</mat-label>
        <mat-icon matPrefix class="mr-2">home</mat-icon>
        <input matInput [formControl]="accNameControl" type="text" name="accName" >
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{'SIGNIN.NAME_PLACEHOLDER' | translate }}</mat-label>
        <mat-icon matPrefix class="mr-2">account_box</mat-icon>
        <input matInput [formControl]="nameControl" type="text" name="name" >
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{'SIGNIN.EMAIL_PLACEHOLDER' | translate }}</mat-label>
        <mat-icon matPrefix class="mr-2">email</mat-icon>
        <input matInput [formControl]="emailControl" type="text" name="email" >
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{'SIGNIN.PASS' | translate }}</mat-label>
        <mat-icon matPrefix class="mr-2">lock</mat-icon>
        <input matInput [formControl]="passControl" type="password" name="password" >
        <mat-hint>{{ 'SIGNIN.PASSWORD_LENGTH' | translate }}</mat-hint>
    </mat-form-field>
    <div>
        <button mat-button (click)="createUserAccount()" [disabled]="!passControl.valid || !emailControl.valid || !nameControl.valid || !accNameControl.valid" color="primary">{{ 'GENERIC.CREATE' | translate }}</button>
    </div>
    

    
</ng-container>